import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import { Icon } from 'modules/Core/Common/Icon';
import { renameObjectKey } from 'modules/Utils/RenameObjectKey';
import ValueContainer from './ValueContainer.component';
import MultiValueRemove from './MultiValueRemove.component';
import * as S from './styles';
import customStyles from './styles';

const MultipleSelect = ({
  options = [],
  className,
  loading,
  setFieldValue,
  placeholder,
  defaultValue,
  name,
  ...rest
}) => {
  if (options.length) {
    options = renameObjectKey(options, 'id', 'value');
    options = renameObjectKey(options, 'name', 'label');
  }

  if (defaultValue && defaultValue.length) {
    defaultValue = renameObjectKey(defaultValue, 'id', 'value');
    defaultValue = renameObjectKey(defaultValue, 'name', 'label');
  }

  const handleChange = useCallback((data) => {
    setFieldValue(name, data);
  }, []);

  return (
    <S.Container className={className} {...rest}>
      <Select
        isMulti
        placeholder={loading ? 'Loading...' : placeholder}
        onChange={handleChange}
        options={options}
        classNamePrefix="multi-select"
        components={{
          ValueContainer,
          MultiValueRemove,
        }}
        value={defaultValue}
        styles={customStyles}
        {...rest}
      />
      <Icon color="#5D6670" name="arrow-down" />
    </S.Container>
  );
};

MultipleSelect.propTypes = {
  setFieldValue: PropTypes.func,
  options: PropTypes.array.isRequired,
  className: PropTypes.string,
  loading: PropTypes.bool,
  defaultValue: PropTypes.any,
  name: PropTypes.string,
  placeholder: PropTypes.string,
};

export { MultipleSelect };
